import { AsyncPipe, CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, input, signal } from '@angular/core';

import { Observable } from 'rxjs';

import '@camelot/icons';
import { ErrorComponent, LoaderComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { Department } from '../../services/dto/department';
import { CamOrganizationsService } from '../../services/organizations.service';

@Component({
  selector: 'cam-department-name',
  templateUrl: './department-name.component.html',
  styleUrls: ['./department-name.component.scss'],
  imports: [CommonModule, AsyncPipe, LoaderComponent, ErrorComponent],
})
export class CamDepartmentNameComponent extends CamBaseComponent {
  departmentId = input.required<string>();

  readonly department$ = signal<Observable<Department | null> | null>(null);

  private _organizationsService = inject(CamOrganizationsService);

  ngOnInit() {
    this.department$.set(this._organizationsService.department.get$(this.departmentId()));
    this._fetch();
  }

  private _fetch() {
    this.requestState.asked();
    this._organizationsService.fetchDepartment$(this.departmentId()).subscribe({
      complete: () => {
        this.requestState.completed();
      },
      error: (error: HttpErrorResponse) => {
        this.requestState.onError(error.status, error.statusText);
      },
    });
  }
}
